import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DealerLogin from './pages/DealerLogin';
import AdminLogin from './pages/AdminLogin';
import Contacts from './pages/ContactUs';
import axios from "axios";
import CryptoJS from 'crypto-js'; // Import the library
import MainLayout from './components/MainLayout';


const API_BASE_URL = "https://api.drivergems.com"; // Replace with FastAPI URL

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dealer-login" element={<DealerLogin />} />
                <Route path="/contacts" element={<Contacts />} />
                <Route path="/admin-login" element={<AdminLogin />} />
                <Route path="/*" element={<MainLayout />} />
            </Routes>
        </Router>
    );
};

export default App;
